import type { BoardSnapshot } from '../schemas.js'
import { exampleBoard } from './example.js'
import { buildFixtureBoard } from './generate.js'
import legacyBoardJson from './legacy-board.json' with { type: 'json' }

export { exampleBoard } from './example.js'
export { buildFixtureBoard, type FixtureSpec } from './generate.js'
export { mulberry32, seededId } from './random.js'

/** A legacy export used by the import tests and the in-app "Load sample legacy file" action. */
export const legacyBoardFixture: unknown = legacyBoardJson

export interface NamedFixture {
  key: string
  label: string
  description: string
  build: () => BoardSnapshot
}

/**
 * Deterministic fixtures required by the stage 1 gate. `perf-2000` spreads 2,000 cards
 * across 10 columns x 20 rows; `dense-cell` puts 500 cards in a single cell so the
 * virtualized droppable can be checked under load.
 */
export const FIXTURES: readonly NamedFixture[] = [
  {
    key: 'example',
    label: 'Sign-up journey (demo)',
    description: 'Small readable board with groups, swimlanes and mixed card fields.',
    build: exampleBoard,
  },
  {
    key: 'perf-100',
    label: '100 cards',
    description: '100 cards across 5 columns x 6 rows.',
    build: () =>
      buildFixtureBoard({
        name: '100 cards',
        seed: 101,
        columns: 5,
        swimlanes: 2,
        rowsPerSwimlane: 3,
        cards: 100,
        groupSize: 2,
      }),
  },
  {
    key: 'perf-2000',
    label: '2,000 cards',
    description: '2,000 cards across 10 columns x 20 rows.',
    build: () =>
      buildFixtureBoard({
        name: '2,000 cards',
        seed: 2000,
        columns: 10,
        swimlanes: 4,
        rowsPerSwimlane: 5,
        cards: 2000,
        groupSize: 3,
      }),
  },
  {
    key: 'dense-cell',
    label: '500 cards in one cell',
    description: '500 cards stacked in a single cell to exercise virtual dragging.',
    build: () =>
      buildFixtureBoard({
        name: '500 cards in one cell',
        seed: 500,
        columns: 3,
        swimlanes: 1,
        rowsPerSwimlane: 2,
        cards: 500,
        concentrate: true,
      }),
  },
]
